import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { forwardRef } from 'react';
import { useAccordionItemContext } from './AccordionItem.js';
import { Collapse } from '../Collapse/index.js';

/**
 * @deprecated Please use AccordionPanelAlpha instead of AccordionPanel moving forward. AccordionPanel will be deprecated in future major releases.
 *
 * ---
 * Accordion allows users to expand one or more panels at a time, revealing information
within a small space.
 *
 * _Note_: AccordionHeader and AccordionPanels have default padding of 'lg', which can be overridden.
 *
 * ### Documentation
 * - [Examples](https://blockparty.endpoint.com/components/accordion#usage)
 * - [Props](https://blockparty.endpoint.com/components/accordion#props)
 * <br />
 *
 */
const AccordionPanel = /*#__PURE__*/forwardRef((_ref, forwardedRef) => {
  let {
    dataTestId = 'accordion-panel',
    children,
    ...rest
  } = _ref;
  const {
    collapsed,
    panelId,
    headerId
  } = useAccordionItemContext();
  return /*#__PURE__*/React__default.createElement(Collapse, _extends({
    ref: forwardedRef,
    "aria-hidden": !collapsed,
    "aria-labelledby": headerId,
    bg: "background",
    borderBottomLeftRadius: "radiusDefault",
    borderBottomRightRadius: "radiusDefault",
    "data-test-id": dataTestId,
    id: panelId,
    isOpen: collapsed,
    overflow: "hidden",
    px: "space30",
    py: "space50",
    role: "region"
  }, rest), children);
});

export { AccordionPanel };
